import React, { useEffect, useState } from 'react';
import { TCarouselListingItem } from 'types/TCarousels';

type FavoritesListProps = {
  title: string;
  favoriteAdItems: TCarouselListingItem[];
  onFavClickHandler: (item: TCarouselListingItem, isFavorite: boolean) => Promise<void>;
};

const ITEM_TYPE_TYPE_USER_FAVORITES = 'user_favorites';
let ListingItemCarousel;

const FavoritesList = ({ title, favoriteAdItems, onFavClickHandler }: FavoritesListProps) => {
  const [listingItemCarouselLoaded, setListingItemCarouselLoaded] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      ListingItemCarousel = (
        await import(/* webpackChunkName: "ListingItemCarousel" */ '../../Carousels/components/ListingItemCarousel')
      ).default;
      setListingItemCarouselLoaded(true);
    })();
  }, []);

  return (
    <>
      {Boolean(favoriteAdItems.length) && listingItemCarouselLoaded && (
        <ListingItemCarousel
          type={ITEM_TYPE_TYPE_USER_FAVORITES}
          title={title}
          items={favoriteAdItems}
          favoriteAdIdList={favoriteAdItems.map(({ itemId }) => itemId)}
          onFavClickHandler={onFavClickHandler}
        />
      )}
    </>
  );
};

export default FavoritesList;
